"use client";
import React, { createContext, useState, useContext, ReactNode } from "react";

export interface RecapPresta {
    pv_id: string;
    dev_id: string;
    v_num_piece: string;
    v_designation: string;
    v_date_presta: string;
    v_cli_civ_nom: string;
    e_nom_responsable: string,
    v_adr_livraison: string;
    v_mode_vente: string;
    v_cnt_civ_nom: string,
    v_cnt_tel_mobile: string,
    e_dp_id: number | null
}

export type RecapPrestaContextType = {
    presta: RecapPresta;
    setPresta: (presta: RecapPresta | ((prevState: RecapPresta) => RecapPresta)) => void;
};

const PrestaContext = createContext<RecapPrestaContextType | undefined>(undefined);

export const PrestaProvider: React.FC<{ children?: ReactNode }> = ({ children }) => {
    const [presta, setPresta] = useState<RecapPresta>({
        pv_id: "",
        dev_id: "",
        v_num_piece: "",
        v_designation: "",
        v_date_presta: "",
        v_cli_civ_nom: "",
        e_nom_responsable: "",
        v_adr_livraison: "",
        v_mode_vente: "",
        v_cnt_civ_nom: "",
        v_cnt_tel_mobile: "",
        e_dp_id: null,
    });

    return (
        <PrestaContext.Provider value={{ presta, setPresta }}>
            {children}
        </PrestaContext.Provider>
    );
};

export const usePresta = () => {
    const context = useContext(PrestaContext);
    if (!context) {
        throw new Error("Erreur Context User");
    }
    return context;
};
